import * as AuditActions from 'audit/AuditActions';
import {EXPORT_AUDIT_LOG_DISPLAY_STRING} from 'audit/AuditConstants';

import makeSimpleActionFunction from './makeSimpleActionFunction';

/**
 * An ActionFunction that exports audit logs for the entities inside the table.
 */
export const exportAuditLogsActionFunction = makeSimpleActionFunction({
  label: EXPORT_AUDIT_LOG_DISPLAY_STRING,
  icon: 'audit-trail',
  iconAltText: EXPORT_AUDIT_LOG_DISPLAY_STRING,
  onInvoke: ({structuredTable}) => {
    AuditActions.exportAuditLogs([structuredTable.apiId ?? '']);
  },
});
